import {Price} from '@aboutyou/grpc-clients/tadarida/aysa_api/models//price.types';
import {Badge} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/badge.types';
import {PriceV2} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/price_v2.types';
import {Product} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/product.types';
import {useTranslation} from '@aboutyou/i18n';
import {BadgeList, PriceBox, Text} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {useCampaignAndSaleBadgeTextByProduct} from '../../shared-deprecated/useCampaignAndSaleBadgeTextByProduct';
import {getDisplayBadges} from './helpers';

interface SizeHeaderProps {
  saleBadges: Badge[];
  product: Product;
  productPrice: Price | PriceV2 | undefined;
  selectedSizePrice?: Price | PriceV2;
  disableBadges?: boolean;
  enableSelectYourSizeTitle?: boolean;
  hideStruckPrices?: boolean;
}

export const SizeHeader: React.FC<SizeHeaderProps> = ({
  saleBadges,
  product,
  productPrice,
  selectedSizePrice,
  disableBadges,
  enableSelectYourSizeTitle,
  hideStruckPrices,
}) => {
  const {t} = useTranslation();

  const options = useCampaignAndSaleBadgeTextByProduct({
    product,
    badges: saleBadges,
  });
  const badgesListHeader = getDisplayBadges(saleBadges, options);

  return (
    <Header
      data-space-out-elements={
        Boolean(badgesListHeader?.length) || enableSelectYourSizeTitle
      }
    >
      {!disableBadges && badgesListHeader && (
        <BadgeList entries={badgesListHeader} disableRoundedCorners={false} />
      )}
      {enableSelectYourSizeTitle && (
        <Text size="px20" weight="mediumHeavy">
          {t('Select your size')}
        </Text>
      )}
      {productPrice && (
        <StyledPriceBox
          price={selectedSizePrice ?? productPrice}
          align="right"
          showVatInNewLine
          hideReductions={hideStruckPrices}
          hideLpl30
          productId={product.id}
        />
      )}
    </Header>
  );
};

const Header = styled.header`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;

  &[data-space-out-elements='true'] {
    justify-content: space-between;
  }
`;

const StyledPriceBox = styled(PriceBox)`
  width: auto;
`;
